import { Pipe, PipeTransform } from '@angular/core';
import {Utilities} from '../utilities/utilities.model';

@Pipe({name: 'commadumper'})

export class NumberFormatPipe implements PipeTransform {
	transform(value: number): number | number {
		if (!Utilities.isVoid(value)) {
			const res = value.toString().replace(',', '');
			return Number.parseInt(res);
		}
	}
}
